import { PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';
import JobResume from '@/components/JobResume';
import JobSearch from '@/components/JobSearch';
import TopPageLinks, { PageLink } from '@/components/TopPageLinks';
import { Job } from '@/types/api';
import * as Styles from './Job.styles';

type Props = PropsWithChildren<{
  topPageLinks: PageLink[];
  job?: Job;
}>;

const JobPage = ({ topPageLinks, job, children }: Props): JSX.Element => {
  return (
    <>
      <Styles.PageHeader>
        <TopPageLinks pageLinks={topPageLinks} />
        <JobSearch />
      </Styles.PageHeader>
      <JobResume job={job} />
      <Outlet />
      {children}
    </>
  );
};

export default JobPage;
